import {useAbout} from "../../store/about";
import NominationOptions from "../About/NominationOptions";

const Nominations = () => {
    const nominations = useAbout((store) => store.nominations)
    return(
        <div className="flex col mb-32 mt-52">
            <h2 className="h2 text-center">
                Our Awards
            </h2>
            <div className="about__card mb-32">
                <NominationOptions props={nominations} className="col"/>
            </div>
        </div>
    )
}
export default Nominations